import React, { useCallback } from 'react';
import { LazyComponent as LazyComponentOrca } from '@fiverr-private/orca';
import { metric } from '../../utils/metric';

const getMetric = (source = 'unknown_source') => `lazy_load.${source}.fail`;

interface LazyComponentProps<C, T> {
    lazyImport: () => Promise<{ default: C }>;
    shouldImport?: boolean;
    source: string;
    onError?: (error: Error) => void;
    componentProps?: T;
}

export const LazyComponent = <C extends React.ReactNode, T extends object>({
    source,
    lazyImport,
    onError,
    shouldImport,
    componentProps,
}: LazyComponentProps<C, T>) => {
    const handleError = useCallback(
        (error) => {
            metric.count(getMetric(source));

            if (onError) {
                onError(error);
            }
        },
        [source, onError]
    );

    return (
        <LazyComponentOrca
            lazyImport={lazyImport}
            shouldImport={shouldImport}
            onError={handleError}
            componentProps={componentProps}
        />
    );
};
